import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-campaign-manager-checklist',
  templateUrl: './help-google-campaign-manager-checklist.component.html'
})
export class HelpGoogleCampaignManagerChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
